import { render, staticRenderFns } from "./ownerManage.vue?vue&type=template&id=0d8613e5&scoped=true&"
import script from "./ownerManage.vue?vue&type=script&lang=js&"
export * from "./ownerManage.vue?vue&type=script&lang=js&"
import style0 from "./ownerManage.vue?vue&type=style&index=0&id=0d8613e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8613e5",
  null
  
)

export default component.exports